import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { isGoogleMapsPlacesReady, loadGoogleMapsApi } from "../../../../utils/googleMaps";

import EventCreationFirstStep from "./EventCreation1";
import EventCreationSecondStep from "./EventCreation2";
import EventCreationThirdStep from "./EventCreation3";
import EventCreationFourthStep from "./EventCreation4";

const EventCreation = (props) => {
  const { getCategories, getEventTypes } = props;
  const [selectedStep, setSelectedStep] = useState(1);
  const [selectedEventInformation, setSelectedEventInformation] = useState({});
  const [inEditMode, setEditMode] = useState(false);
  const [googleMapsReady, setGoogleMapsReady] = useState(isGoogleMapsPlacesReady);
  const [mapsLoadError, setMapsLoadError] = useState(null);
  const [mapsLoading, setMapsLoading] = useState(!isGoogleMapsPlacesReady());

  const storageSelectedEventInformation = JSON.parse(
    localStorage.getItem("selectedEventInformation")
  );
  useEffect(() => {
    getCategories();
    getEventTypes();
    if (storageSelectedEventInformation) {
      setSelectedEventInformation(storageSelectedEventInformation);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadMaps = () => {
    if (isGoogleMapsPlacesReady()) {
      setGoogleMapsReady(true);
      setMapsLoadError(null);
      setMapsLoading(false);
      return;
    }

    setMapsLoading(true);
    setMapsLoadError(null);

    loadGoogleMapsApi()
      .then(() => {
        setGoogleMapsReady(true);
        setMapsLoadError(null);
      })
      .catch((error) => {
        setMapsLoadError(
          error?.message ||
            "Unable to load Google Maps. Location search and maps will not work until this is resolved.",
        );
      })
      .finally(() => setMapsLoading(false));
  };

  useEffect(() => {
    loadMaps();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (Object.keys(selectedEventInformation).length !== 0)
      localStorage.setItem(
        "selectedEventInformation",
        JSON.stringify(selectedEventInformation)
      );
  }, [selectedEventInformation]);
  
  if (!googleMapsReady) {
    return (
      <div className="event-cre-wrap text-center py-5">
        {mapsLoading && <Spin />}
        {mapsLoadError && (
          <div className="px-3">
            <p style={{ color: "red", marginBottom: 16 }}>{mapsLoadError}</p>
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={loadMaps}
              disabled={mapsLoading}
            >
              Retry
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="event-cre-wrap">
      {selectedStep === 1 ? (
        <EventCreationFirstStep
          {...props}
          inEditMode={inEditMode}
          setEditMode={setEditMode}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          selectedEventInformation={selectedEventInformation}
          setSelectedEventInformation={setSelectedEventInformation}
        />
      ) : selectedStep === 2 ? (
        <EventCreationSecondStep
          inEditMode={inEditMode}
          setEditMode={setEditMode}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          selectedEventInformation={selectedEventInformation}
          setSelectedEventInformation={setSelectedEventInformation}
        />
      ) : selectedStep === 3 ? (
        <EventCreationThirdStep
          inEditMode={inEditMode}
          setEditMode={setEditMode}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          selectedEventInformation={selectedEventInformation}
          setSelectedEventInformation={setSelectedEventInformation}
        />
      ) : (
        <EventCreationFourthStep
          {...props}
          inEditMode={inEditMode}
          setEditMode={setEditMode}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          selectedEventInformation={selectedEventInformation}
          setSelectedEventInformation={setSelectedEventInformation}
        />
      )}
    </div>
  );
};

export default EventCreation;
